<template>
  <component :is="currentLayout">
    <router-view />
  </component>
</template>

<script>
import MainLayout from './MainLayout.vue';
import ProfessionalLayout from './ProfessionalLayout.vue';
import { ROLES } from '@/constants/roles';
import { mapGetters } from 'vuex';

export default {
  name: 'LayoutWrapper',
  components: {
    MainLayout,
    ProfessionalLayout,
  },
  computed: {
    ...mapGetters('auth', ['userRole']),
    currentLayout() {
      // If user is Professional, use ProfessionalLayout
      // Otherwise use MainLayout (for Admin, SuperAdmin, etc.)
      return this.userRole === ROLES.PROFESSIONAL
        ? 'ProfessionalLayout'
        : 'MainLayout';
    },
  },
};
</script>
